/* eslint-disable react/no-string-refs */
import React from 'react';
import moment from 'moment';
import defaultMonths from '../../../../constants/months';
import { withNamespaces } from 'react-i18next';

const now = new Date();

class MonthSelector extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.isDisableMonth = this.isDisableMonth.bind(this);
  }

  onChange(e) {
    this.props.onChange(e && e.target.value);
  }

  isDisableMonth(month) {
    const { currentLastDayOfMonth, currentYear } = this.props;
    const momentNow = moment(now);
    const lastDayOfMonth = moment(currentLastDayOfMonth, 'DD-MM-YYYY HH:mm');
    const currentMonth = (momentNow.month()) + 1;
    const year = momentNow.year();
    const isLessThanNow = lastDayOfMonth.isBefore(momentNow);

    if (isLessThanNow) {

      return (currentYear >= year) && (currentMonth < month);
    }


    if (Number(currentYear)  === year-1 && currentMonth === 1 && month === 12) {
      return false; //  12.ay seçilebilir
    }

    return currentMonth <= month;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="form-group" style={{ marginBottom: 0 }}>
        {this.props.title ? (
          <label>
            {this.props.title}
          </label>
        ) : null}


        { this.props.filterMonth
          ? (
            <select
              ref="select"
              className="form-control input-sm border-input select-input"
              value={this.props.value || 0}
              onChange={this.onChange}
              id="month"
            >
              {
                    defaultMonths.months.map(month => (
                      <option key={month.index} value={month.index} disabled={this.isDisableMonth(month.index)}>
                        {t(month.value)}
                      </option>
                    ))
                }
            </select>
          )
          : (
            <select
              ref="select"
              id="month1"
              className="form-control input-sm border-input select-input"
              value={this.props.value || 0}
              onChange={this.onChange}
            >
              {
                  defaultMonths.months.map(month => (
                    <option key={month.index} value={month.index}>
                      {t(month.value)}
                    </option>
                  ))
              }
            </select>
          )

        }
      </div>
    );
  }
}

export default withNamespaces()(MonthSelector);



// WEBPACK FOOTER //
// ./src/components/common/selector/month/index.js